export const arePropsEqual = (objA, objB, keys) => {
  return keys.every(key => {
    if (Array.isArray(key)) {
      // Nested property
      const [parent, child] = key
      return objA[parent]?.[child] === objB[parent]?.[child]
    }
    return objA[key] === objB[key]
  })
}